import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Promotion = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Promotion;
